import { useThemeQueries } from "../../../theme";
import { DefaultCard } from "../components";
import { Box, Button, CircularProgress, ClickAwayListener, Grid, Tooltip, Typography } from "@material-ui/core";
import { isEmpty } from "lodash";
import { toDateString } from "../../../../utils/to-date";
import { CardPedidoMotoboyProps } from "./card-pedido-motoboy-props";
import { useCallback, useMemo, useState } from "react";
import { useToastSaurus } from "../../../../services/app";
import { MapsIcon } from "../../icons/maps-icon";
import { PedidoEnderecoModel } from "../../../../model/api/pedidos/pedido-model";
import { CardProdutosMotoboy } from "../card-produtos-motoboy/card-produtos-motoboy";
import { useStyles } from "./card-pedido-motoboy-styles";
import { useContratoAtual } from "../../../../services/app/use-cases/contrato-atual";
import { EnumContratoConfig } from "../../../../model/enums/enum-contrato-config";
import { toDecimalString } from "../../../../utils/to-decimal";
import { OkIcon } from "../../icons/ok-icon";
import { DeliveryIcon } from "../../icons/delivery-icon";
import { guidEmpty } from "../../../../utils/guid-empty";
import { usePedidos } from "../../../../hooks/pedidos";
import { useHistory } from "react-router-dom";
import { useGetLocalizacaoUsuario } from "../../../../data/api/localizacao/get-localizacao-usuario";
import { useRotasOtimizadasStore } from "../../../../services/app/stores/rotas-otimizadas";
import classNames from "classnames";
import { InformacaoIcon } from "../../icons";
import { PessoaIcon } from "../../icons/pessoa-icon";
import { useDialog } from "../../../../services/app/providers/dialog-provider";

export const CardPedidoMotoboy = ({ pedido, handleReloadPedidos, qtdePedidos, pedidoDestaqueProcurado }: CardPedidoMotoboyProps) => {

    //AUX
    const { theme } = useThemeQueries();
    const { getConfigByCod } = useContratoAtual()
    const classes = useStyles();
    const { alterarEntregadorPedido, searchPedido } = usePedidos()
    const { showToast } = useToastSaurus()
    const history = useHistory()
    const { obterLocalizacao } = useGetLocalizacaoUsuario()
    const [carregandoLocalizacao, setCarregandoLocalizacao] = useState(false)
    const [openTooltip, setOpenTooltip] = useState(false)
    const { abrirAssumirEntrega } = useDialog()

    const produtoEntrega = getConfigByCod(EnumContratoConfig.ProdutoEntrega) as string
    const pontosRotasPedidos = useRotasOtimizadasStore(state => state.pontosRotasPedidos)

    const retornaEndereco = useCallback(() => {
        const { bairro, municipio, numero, complemento, logradouro, uf, cep, pontoReferencia } = pedido?.enderecoEntrega ?? new PedidoEnderecoModel()

        if (isEmpty(pedido?.enderecoEntrega)) {
            return ''
        }

        return `${logradouro ?? ''}, ${numero ?? 0} - ${bairro ?? ''}${municipio ? `, ${municipio}` : ''}${uf ? ` - ${uf}` : ''}${complemento ? `, ${complemento}` : ''}${cep ? ` - ${cep}` : ''}${pontoReferencia ? `, ${pontoReferencia}` : ''}`
    }, [pedido?.enderecoEntrega])

    const getLinkGoogleMaps = useCallback(async () => {
        try {
            setCarregandoLocalizacao(true)
            showToast('info', 'Calculando rota...')
            const minhaLocalizacao = await obterLocalizacao()
            const origin = `origin=${minhaLocalizacao?.latitude?.toString()},${minhaLocalizacao?.longitude?.toString()}`
            const enderecoEntrega = `${pedido?.enderecoEntrega?.logradouro},${pedido?.enderecoEntrega?.numero},${pedido?.enderecoEntrega?.bairro},${pedido?.enderecoEntrega?.municipio},${pedido?.enderecoEntrega?.uf}`

            const link = `https://www.google.com/maps/dir/?api=1&${origin}&destination=${enderecoEntrega}&travelmode=motorcycle`

            showToast('success', 'Rota calculada com sucesso!')
            return window.open(link, '_blank');
        } catch (err: any) {
            showToast('error', err.message)
        } finally {
            setCarregandoLocalizacao(false)
        }
    }, [obterLocalizacao, pedido?.enderecoEntrega?.bairro, pedido?.enderecoEntrega?.logradouro, pedido?.enderecoEntrega?.municipio, pedido?.enderecoEntrega?.numero, pedido?.enderecoEntrega?.uf, showToast])

    const filtrarProdutos = pedido?.produtos.filter(prod => prod.produtoIdReferencia !== produtoEntrega)

    const onClickVincularComoEntregador = useCallback(() => {
        abrirAssumirEntrega(
            {
                onClickAssumir: async (alterarStatusEntrega?: boolean) => {
                    const pedidoAtualizado = await searchPedido(pedido.id)
                    if (pedido.entregadorId && pedidoAtualizado.entregadorId !== guidEmpty()) {
                        showToast('error', 'Este pedido já está sendo entregue por outro entregador.')
                        return
                    }

                    await alterarEntregadorPedido(pedido, alterarStatusEntrega)
                    showToast('success', 'Entregador vinculado com sucesso.')
                    if (qtdePedidos && qtdePedidos === 1) {
                        history.replace('/')
                    } else {
                        handleReloadPedidos()
                    }
                },
                aberto: true
            },
        )
    }, [abrirAssumirEntrega, alterarEntregadorPedido, handleReloadPedidos, history, pedido, qtdePedidos, searchPedido, showToast])

    const onClickVisualizarEntrega = useCallback(() => {
        try {
            history.push({
                pathname: 'confirmar-entrega',
                search: `?modulo=motoboy`,
                state: {
                    pedido
                }
            })
        } catch (err: any) {
            showToast('error', err.message)
        }
    }, [history, pedido, showToast])

    const handleCloseTooltip = useCallback(() => setOpenTooltip(false), [])

    const handleOpenTooltip = useCallback(() => setOpenTooltip(prev => !prev), [])

    const cardPedido = useMemo(() => {
        return (
            <>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <DefaultCard className={classes.defaultCard} isClickable={false}>
                        {pedidoDestaqueProcurado && (
                            <Box className={classNames(classes.aviso, classes.avisoPedidoDestacado)}>
                                <DeliveryIcon tipo="BUTTON_PRIMARY" />
                                <Typography>Pedido à procura</Typography>
                            </Box>
                        )}
                        {pedido.entregadorId && pedido.entregadorId !== guidEmpty() && (pontosRotasPedidos && pontosRotasPedidos.length > 0) && !pontosRotasPedidos.includes(pedido.id) && (
                            <Box className={classNames(classes.aviso, classes.avisoRotaNaoOtimizada)}>
                                <DeliveryIcon tipo="BUTTON_PRIMARY" />
                                <Typography>Fora da Sequência</Typography>
                                <ClickAwayListener onClickAway={handleCloseTooltip}>
                                    <Tooltip
                                        disableFocusListener
                                        disableHoverListener
                                        disableTouchListener
                                        title={'Este pedido não faz parte da rota otimizada. Gere a rota novamente.'}
                                        open={openTooltip}
                                        onClose={handleCloseTooltip}
                                        placement="top-end"
                                        arrow
                                    >
                                        <Box display="flex" alignItems="center" className={classes.iconInfo}>
                                            <InformacaoIcon
                                                tipo="BUTTON"
                                                fill={theme.palette.common.white}
                                                onClick={handleOpenTooltip} />
                                        </Box>
                                    </Tooltip>
                                </ClickAwayListener>
                            </Box>
                        )}
                        <Grid container spacing={2} style={{
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                            <Grid item xs={12}>
                                <Grid container>
                                    <Grid item xs={6}>
                                        <Typography
                                            variant="h6"
                                            color="textPrimary"
                                            style={{
                                                lineHeight: .7
                                            }}
                                        >
                                            <Box fontWeight={700}>
                                                <span style={{ color: theme.palette.primary.main, fontWeight: 700, fontSize: 24 }}>#</span> {pedido?.codigoPedido}
                                            </Box>
                                        </Typography>
                                    </Grid>

                                    <Tooltip arrow title="Data de Inserção">
                                        <Grid item xs={6} style={{
                                            display: 'flex',
                                            justifyContent: 'flex-end'
                                        }}>
                                            <Typography
                                                variant="body2"
                                                color="primary"
                                            >
                                                <Box fontWeight={600}>
                                                    {toDateString(new Date(pedido?.systemInsertDate), 'DD/MM/yyyy - HH:mm')}
                                                </Box>
                                            </Typography>
                                        </Grid>
                                    </Tooltip>
                                    <Grid item xs={12} style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        paddingTop: theme.spacing(1)
                                    }}>
                                        <PessoaIcon tipo="BUTTON" />
                                        <Typography
                                            variant="h6"
                                            color="textPrimary"
                                        >
                                            <Box fontWeight={700}>
                                                {!isEmpty(pedido?.cliente.razaoSocial) ? pedido?.cliente.razaoSocial : 'Consumidor'}
                                            </Box>
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} style={{
                                display: 'flex',
                            }}>
                                <Box width='100%' mr={1}>
                                    <Grid container className={classes.cardEndereco}>
                                        <Grid item xs={12}>
                                            <Typography
                                                variant="body2"
                                                color="textSecondary"
                                            >
                                                {retornaEndereco()}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <div>
                                    <Tooltip arrow title='Mapa'>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            onClick={carregandoLocalizacao ? undefined : getLinkGoogleMaps}
                                            style={{
                                                height: '56px',
                                                width: '56px'
                                            }}
                                        >
                                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                                {carregandoLocalizacao
                                                    ? <CircularProgress size={20} color="inherit" />
                                                    : <MapsIcon tipo="BUTTON_PRIMARY" style={{ marginRight: '0px' }} />
                                                }
                                            </span>
                                        </Button>
                                    </Tooltip>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <CardProdutosMotoboy
                                    pedido={pedido}
                                    produtos={filtrarProdutos}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box display="flex" justifyContent="space-between">
                                    <Typography>
                                        Frete:
                                    </Typography>
                                    <Typography>
                                        <Box fontWeight={500}>
                                            R$ {toDecimalString(pedido.valorTotalFrete)}
                                        </Box>
                                    </Typography>
                                </Box>
                                <Box display="flex" justifyContent="space-between">
                                    <Typography>
                                        Total:
                                    </Typography>
                                    <Typography>
                                        <Box fontWeight={500}>
                                            R$ {toDecimalString(pedido.valorTotalPedido)}
                                        </Box>
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                {(!pedido.entregadorId || pedido.entregadorId === guidEmpty()) ? (
                                    <Button fullWidth variant="outlined" color="primary" onClick={onClickVincularComoEntregador}>
                                        <DeliveryIcon tipo="BUTTON" />
                                        Assumir entrega
                                    </Button>
                                ) : (
                                    <Button fullWidth variant="contained" color="primary" className={classes.confirmarBtn} onClick={onClickVisualizarEntrega}>
                                        <OkIcon tipo="BUTTON_PRIMARY" />
                                        Confirmar Entrega
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    </DefaultCard>
                </Grid>
            </>
        )
    }, [classes.defaultCard, classes.aviso, classes.avisoPedidoDestacado, classes.avisoRotaNaoOtimizada, classes.iconInfo, classes.cardEndereco, classes.confirmarBtn, pedidoDestaqueProcurado, pedido, pontosRotasPedidos, handleCloseTooltip, openTooltip, theme, handleOpenTooltip, retornaEndereco, carregandoLocalizacao, getLinkGoogleMaps, filtrarProdutos, onClickVincularComoEntregador, onClickVisualizarEntrega])

    return cardPedido
}